import React from 'react'

const AppIcon = ({ className = '', ...props }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none"
      className={`transition-colors duration-200 ${className}`}
      {...props}
    >
      <path 
        d="M4 10C4 6.229 4 4.343 5.172 3.172C6.344 2.001 8.229 2 12 2C15.771 2 17.657 2 18.828 3.172C19.999 4.344 20 6.229 20 10V14C20 17.771 20 19.657 18.828 20.828C17.656 21.999 15.771 22 12 22C8.229 22 6.343 22 5.172 20.828C4.001 19.656 4 17.771 4 14V10Z" 
        stroke="currentColor" 
        strokeWidth="1.5"
      />
      <path 
        d="M15 18.9999H8.99995M16.748 2.37793L16.664 2.50393C15.908 3.63793 15.53 4.20493 14.978 4.54793C14.868 4.6166 14.7543 4.6776 14.637 4.73093C14.045 5.00093 13.363 5.00093 12 5.00093C10.637 5.00093 9.95595 5.00093 9.36395 4.73093C9.24613 4.67737 9.13189 4.61624 9.02195 4.54793C8.46995 4.20493 8.09195 3.63793 7.33595 2.50393L7.25195 2.37793" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round"
      />
    </svg>
  )
}

export default AppIcon
